import { maxLength, pipe, string } from 'valibot'

import { VALIDATION_MESSAGES } from '@/constants/common/validation.constants'

// 文字数上限は BE の create-site.dto.ts の @MaxLength と一致させること
export const siteDisplayNameMiddleRule = pipe(
  string(),
  maxLength(20, VALIDATION_MESSAGES.MAX_LENGTH(20))
) // 中表示名称

export const siteDisplayNameShortRule = pipe(
  string(),
  maxLength(10, VALIDATION_MESSAGES.MAX_LENGTH(10))
) // 短表示名称
